const PLACEHOLDER_EMAIL = "john@doe.com";
const PLACEHOLDER_PASSWORD = "********";

export { PLACEHOLDER_EMAIL, PLACEHOLDER_PASSWORD };
